import React, { useState, useEffect } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getInventorySuppliers } from "../../../api/inventoryService";

const SupplierAutocomplete = ({
  value,
  onChange,
  label = "Select Supplier",
  ...props
}) => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await getInventorySuppliers();
          setSuppliers(response?.data || []);
        } catch (error) {
          console.error("Error fetching items:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, [value]);

  const handleInputChange = async (event, inputValue, reason) => {
    if (reason === "input") {
      if (inputValue.length >= 2) {
        setLoading(true);
        try {
          const response = await getInventorySuppliers(1, 10, inputValue);
          setSuppliers(response?.data || []);
        } catch (error) {
          console.error("Error fetching suppliers:", error);
        } finally {
          setLoading(false);
        }
      } else {
        // Clear suppliers if input is less than 2 characters
        setSuppliers([]);
      }
    }
  };

  const handleChange = (event, newValue) => {
    if (!newValue) {
      // User clicked clear (x) → clear options too
      setSuppliers([]);
    }
    onChange?.(newValue ? newValue.id : "");
  };

  return (
    <Autocomplete
      {...props}
      options={suppliers}
      getOptionLabel={(option) => option.name || ""}
      value={suppliers.find((supplier) => supplier.id === value) || null}
      onChange={handleChange}
      onInputChange={handleInputChange}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SupplierAutocomplete;
